// @flow
/**
 * IllegalStateException
 */
class IllegalStateException extends Error {
  constructor(message: string) {
    super(message);
    this.name = "IllegalStateException";
  }
}

export default IllegalStateException;
